import React from "react";
import PropTypes from "prop-types";

function ImageBox({ src, alt }) {
  return (
    <div className="img-box">
      <img src={src} alt={ alt || "icon"} />
    </div>
  );
}

ImageBox.propTypes = {
    src : PropTypes.string.isRequired,
    alt: PropTypes.string,
};

export default ImageBox;
